import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { useAppSelector } from "@/store/hooks";
import { budgetDetailsStartDateSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsStartDateSelector";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";
import NotStartedBudget from "@/assets/empty-states/not_started_budget.svg";

export const BudgetDetailsNotStarted: FC = () => {
  const startDate = useAppSelector(budgetDetailsStartDateSelector);

  return (
    <Stack
      flex={1}
      spacing={3}
      bgcolor="grey.50"
      alignItems="center"
      justifyContent="center"
    >
      <img src={NotStartedBudget} alt="Not started budget" />
      <Typography variant="h6" fontWeight="normal">
        {startDate
          ? `This budget starts on ${formatDate(startDate, { type: "longDate" })}`
          : "This budget has not started yet."}
      </Typography>
    </Stack>
  );
};
